<template>
  <div class="fcc-row">
    <div class="holder">
      <h3>{{title}}</h3>
      <div class="divider" />
      <div class="row-elements">
        <div
          class="row-element-holder"
          v-for="(item, index) in row"
          :key="item.image"
          :data-aos-delay="index*200"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out-cubic"
        >
          <div class="image">
            <img :src="require(`@/assets/row/${item.image}`)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FCTitle from "@/components/patterns/FCTitle";
export default {
  components: {
    FCTitle
  },
  props: {
    row: Array,
    title: String
  }
};
</script>

<style lang="scss" scoped>
.fcc-row {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 53%,
    rgba(0, 0, 0, 0.84) 100%
  );
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  min-height: 100%;
}
.holder {
  margin-top: 200px;
  padding: 0 100px;
  z-index: 1;
  position: relative;
}
.divider {
  background-image: linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 1%,
    #ffffff 36%,
    #ffffff 69%,
    rgba(255, 255, 255, 0) 100%
  );
  height: 2px;
  width: 100%;
  margin: 20px 0;
  content: " ";
  display: block;
}
.row-elements {
  text-align: center;
}
.row-element-holder {
  display: inline-block;
  box-sizing: border-box;
  white-space: normal;
  color: #fff;
  letter-spacing: 0;
  text-transform: uppercase;
  &:not(:last-child) {
    margin-right: 25px;
  }
  .label {
    font-size: 28px;
    text-align: center;
    line-height: 28px;
    font-weight: bold;
    margin: 10px 0;
  }
  .image {
    img {
      height: 45vh;
      object-fit: cover;
      object-position: top;
    }
  }
}
h3 {
  font-weight: bold;
  font-size: 42px;
  color: #ff5100;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
}
@media (max-width: 1000px) {
  .holder {
    margin-top: 90px;
  }
}
</style>